import React, {Component} from 'react';
import JobListRow from "./JobListRow";
import SortableHead from '../common/list/SortableHead';
import * as jobActions from '../../actions/jobActions';
import { injectIntl } from 'react-intl';
import {messages} from  '../common/Translations';

class JobsList extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        const {
            jobs,
            listId,
            intl
        } = this.props;
        return (
            <table id="tech-companies-1" className="table table-striped">
                <SortableHead
                    listId={listId}
                    action={jobActions.loadJobs}
                    columns={[
                        {
                            title: intl.formatMessage(messages.listColumnTitleHeading),
                            name: 'title',
                        },
                        {
                            title: intl.formatMessage(messages.jobListColumnPublishedAt),
                            name: 'created',
                        },
                        {
                            title: intl.formatMessage(messages.jobListColumnExpirationDate),
                            name: 'endDate',
                        },
                        {
                            title: intl.formatMessage(messages.listColumnTitleOptions),
                            className: 'text-right'
                        },
                    ]}
                />
                <tbody>
                {
                    jobs.map(job =>
                        <JobListRow
                            key={job.id}
                            job={job}
                            cloneJob={this.props.cloneJob}
                            showJobDeleteModal={this.props.showJobDeleteModal}
                        />
                    )
                }
                </tbody>
            </table>
        )
    }
}

export default injectIntl(JobsList);




// WEBPACK FOOTER //
// ./web/src/components/jobs/JobsList.jsx